<div class="row m-0" style="height: calc(100% - 60px)">
  <div class="prescription-container col-5 h-100 p-5">
    <div *ngIf="showDownloadBtn">
      something went wrong click
      <a
        href="{{ PREFIX_MEDREVIEW_PV1_IMAGES }}'{{ activeMedication.document_path }}"
        target="_blank"
        >here</a
      >
      to download the image
    </div>
    <pinch-zoom>
      <div
        style="
          width: 100%;
          height: 100%;
          position: relative;
          display: flex;
          justify-content: center;
        "
      >
        <mat-spinner *ngIf="loadingTif | async" class="align-self-center"></mat-spinner>
        <img
          *ngIf="!(loadingTif | async)"
          style="position: absolute; max-height: 100%; max-width: 100%"
          [src]="presImage"
        />
      </div>
    </pinch-zoom>
  </div>
  <div class="cards-container col-7 h-100 p-5">
    <div>
      <ng-content></ng-content>
    </div>
    <div
      class="card card-custom ks-mb-2 d-flex align-items-center rounded-top pr-1 p-3 doctor-details-container"
    >
      <div class="d-flex w-100" style="justify-content: space-between">
        <div>Prescriber: {{ getDoctorName(activeMedication) || '-' }}</div>
        <div>NPI: {{ activeMedication.npi || '-' }}</div>
        <div>DEA: {{ activeMedication.prescription?.doctor?.dea || '-' }}</div>
        <div>SLN: {{ activeMedication.sln || '-' }}</div>
      </div>
    </div>
    <p class="ks-body-md ks-text-neutral ks-mb-2">
      Single-click to select and verify an item; double-click to assign an error to it.
    </p>

    <div class="cards-medication-container">
      <ng-container *ngFor="let card of patientReviewData">
        <kt-med-review-card
          *ngIf="activeMedication.document_path == card.document_path"
          [data]="card"
          [statusKey]="card.classification"
          [isPv]="true"
          [verifyMedication]="triggerVerify.bind(this)"
          [markErrorFn]="triggerError.bind(this)"
        ></kt-med-review-card>
      </ng-container>
    </div>

    <button
      (click)="verifyCards()"
      [disabled]="numberOfVerified == 0"
      mat-flat-button
      [color]="numberOfVerified == 0 ? 'grey' : 'primary'"
      class="w-100"
    >
      Mark Selected Rx as Verified
    </button>
  </div>
</div>
<div class="text-center p-5" style="height: 60px">
  <div class="d-inline-block mr-3">
    <span
      *ngIf="prescriptionIndex > 1"
      class="clickable"
      matTooltip="Back to previous status"
      (click)="previousPrescriptions()"
      ><i class="flaticon2-left-arrow icon-md"></i>
    </span>
  </div>
  <span [innerHTML]="prescriptionIndex | safe : 'html'"></span> of
  <span [innerHTML]="totalPrescriptions | safe : 'html'"></span>
  <div class="d-inline-block ml-3">
    <span
      *ngIf="prescriptionIndex < totalPrescriptions"
      class="clickable"
      matTooltip="Move to next status"
      (click)="nextPrescriptions()"
    >
      <i class="flaticon2-right-arrow icon-md"></i
    ></span>
  </div>
</div>
